var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNurse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 22H4V20C4.4 17.6 7.5 16.6667 9 16.5L12 21L15 16.5C17.8 16.5 20 18.5 20 20V22Z",
    stroke: "#0D2645"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8H8V10C8 15.5 16 15.5 16 10V8Z",
    stroke: "#0D2645"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7H16L15.545 2.45025C15.5195 2.19465 15.3044 2 15.0475 2H8.95249C8.69562 2 8.48054 2.19465 8.45498 2.45025L8 7Z",
    stroke: "#0D2645"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M10 4.5H13M11.5 3V6",
    stroke: "#0D2645"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNurse);
export default __webpack_public_path__ + "static/media/nurse.a3294ea20189c4e4f0ca4e174abd1402.svg";
export { ForwardRef as ReactComponent };